import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SnoozeIcon from "@mui/icons-material/Snooze";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import React from "react";
import { useLocation } from "react-router-dom";
import { useDashboardAlerts } from "../../hooks/react-query/alerts/useDashboardAlerts";
import { useDismissAlert } from "../../hooks/react-query/alerts/useDismissAlert";
import { AlertSeverity } from "../../pages/Alerts/alertsMockData";
import { AlertSnoozeMenu } from "../../pages/Alerts/components/AlertSnoozeMenu";
import "./dashboardAlertWidget.scss";

const SEVERITY_ICONS: Record<AlertSeverity, React.ReactNode> = {
  critical: <ErrorOutlineIcon fontSize="small" />,
  warning: <WarningAmberIcon fontSize="small" />,
  info: <InfoOutlinedIcon fontSize="small" />,
};

// Self-sufficient by design (reads its own route via useLocation, no props required) so it can be
// dropped into DefaultPageContent.tsx and IframeLayout.tsx without threading a new prop through
// the ~20+ existing call sites of either. Renders nothing if no alert targets the current route.
export const DashboardAlertWidget = () => {
  const location = useLocation();
  const { alerts } = useDashboardAlerts(location.pathname);
  const { mutate: dismiss } = useDismissAlert();

  if (alerts.length === 0) return null;

  return (
    <div className="dashboard_alert_widget" data-test-id="dashboard-alert-widget">
      {alerts.map((alert) => (
        <div
          key={alert.alert_id}
          className={`dashboard_alert_widget_item dashboard_alert_widget_item--${alert.severity}`}
          data-test-id={`dashboard-alert-${alert.alert_id}`}
        >
          <div className="dashboard_alert_widget_item_icon">{SEVERITY_ICONS[alert.severity]}</div>
          <div className="dashboard_alert_widget_item_text">
            <strong>{alert.title}</strong>
            <span>{alert.message}</span>
          </div>
          <div className="dashboard_alert_widget_item_actions">
            <AlertSnoozeMenu
              alertId={alert.alert_id}
              triggerContent={
                <>
                  <SnoozeIcon fontSize="small" />
                  Snooze
                </>
              }
            />
            <button onClick={() => dismiss(alert.alert_id)} data-test-id={`dashboard-alert-dismiss-${alert.alert_id}`}>
              <CloseIcon fontSize="small" />
              Dismiss
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
